import Processor from './Processor/Processor'
import EnhanceStrategy from './Processor/Strategies/EnhanceStrategy'
import GenerateStrategy from './Processor/Strategies/GenerateStrategy'

export { EnhanceStrategy, GenerateStrategy }

export default Processor
